@if (user()) {
	@if ('showAllHistory' | userPermission | async) {
		@if (user().prerequisits.length === 0) {
			<div>
				<a routerLink="/release-notes.do?doShowReleaseNotes=1">
					{{"frame.footer.history" | msgKey}}
				</a>
			</div>
		}
	}
}
